<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca5"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="freight_search_button" @click="funcFilter()">
          查询
        </el-button>
        <el-button
          v-if="freight_clearAll_button"
          @click="$refs.xTable.clearSelection()"
        >
          清除所有行选中
        </el-button>
        <el-button v-if="freight_batchHandle_button" @click="getSelectEvent()">
          批量核算
        </el-button>
        <el-button
          v-if="getLimit('freight_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :header-cell-class-name="headerCellClassName"
      :cell-class-name="cellClassName"
      :row-class-name="rowClassName"
      show-footer
      :footer-method="footerMethod"
      :data="tableData"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 申请状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="applyStatus"
          title="驳回状态"
          :formatter="formatterApplyStatus"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.applyStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in applyStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="isReceiptReturn"
          :formatter="formatterReceiptStatus"
          title="纸质回单状态"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isReceiptReturn"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in receiptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin && isShowTxStatus == 1">
        <vxe-table-column
          field="txStatus"
          title="上链状态"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'txStatus')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.txStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.txStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- start -->
      <!-- form.deliveryFeePractical > form.calculatePriceStandard -->

      <!-- <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="运费判断"
          min-width="200"
          sortable
        >
          <template v-slot:default="{ row }">
            {{ row.isFreight ? "是" : "否" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <!-- 车辆经营性质 -->
      <vxe-table-column>
        <vxe-table-column
          field="vehicleNatureStatus"
          title="车辆经营性质"
          :formatter="formatterVehicleNatureStatus"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleNatureStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in vehicleNatureStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="trackFlag"
          title="轨迹判断"
          min-width="200"
          sortable
        >
          <template v-slot:default="{ row }">
            <div :style="{ color: row.trackFlag !== 8 ? 'red' : '' }">
              {{ formatterTrackFlag(row) }}
            </div>
          </template>
        </vxe-table-column>

        <template v-slot:header>
          <el-select
            v-model="listQuery.trackFlag"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in tackList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 运费判断 -->
      <vxe-table-column>
        <vxe-table-column
          field="freightValid"
          title="运费判断"
          min-width="200"
          sortable
        >
          <template v-slot:default="{ row }">
            <div :style="{ color: row.freightValid === 1 ? 'red' : '' }">
              {{ formatterFreightValid(row) }}
              <span>(最大运费为:{{ row.maxFreight }})</span>
            </div>
          </template>
        </vxe-table-column>

        <template v-slot:header>
          <el-select
            v-model="listQuery.freightValid"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in freightValidList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeePractical"
          title="实际承运人应收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- end -->
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="托运人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isTransfer"
          title="是否调单"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.isTransfer > 0 ? "是" : "否" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isTransferSearch"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isTransferSearchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="输入运输要求"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadPlace"
          title="实际操作装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadPlace"
            placeholder="请输入实际操作装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadPlace"
          title="实际操作卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.unloadPlace"
            placeholder="请输入实际操作卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="里程数(公里)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="接单数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="wastage"
          title="货物损耗"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.wastageStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.wastageEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settlementWeight"
          title="结算吨位"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.settlementWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.settlementWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxPrice"
          title="托运人成交单价(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxFee"
          title="托运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="payTaxAmount"
          title="托运人预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payTaxAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payTaxAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人应付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualFreight"
          title="托运人实付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualCash"
          title="托运人实付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipperDeliveryFee"
          title="托运人合计付款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxPayFee"
          title="服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="realPrice"
          title="实际承运人承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="实际承运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="platformPrepayment"
          title="平台预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.platformPrepaymentStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.platformPrepaymentEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="driverActualFreight"
          title="实际承运人实收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="driverActualCash"
          title="实际承运人实收现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="deliveryCashFee"
          title="实际承运人合计收款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryCashFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryCashFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="extraFee"
          title="其他费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.extraFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.extraFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="abnormalFee"
          title="异常费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.abnormalFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.abnormalFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="payOil"
          title="平台预付油点(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="payAmount"
          title="平台预付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="allotOil"
          title="已分配油费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.allotOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.allotOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="orderGmtCreated"
          title="下单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.orderGmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'orderGmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="接单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="最后操作人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="220" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="freight_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="handleClick(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!-- v-if="freight_trajectory_button" -->
          <!-- <el-tooltip
            class="item"
            effect="dark"
            content="运单轨迹"
            placement="top"
          >
            <vxe-button type="text" @click="positionFunc(scope.row.code)">
              <em class="el-icon-location-information" />
            </vxe-button>
          </el-tooltip> -->
          <el-tooltip
            v-if="
              (freight_reject_button && scope.row.applyStatus !== 2) ||
                (freight_reject_button && scope.row.appealStatus === 0)
            "
            class="item"
            effect="dark"
            content="驳回"
            placement="top"
          >
            <vxe-button type="text" @click="rejectClick(scope.row.code)">
              <i class="el-icon-remove-outline" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="freight_edit_button"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="businessClick(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="freight_splitOrder_button && scope.row.isSplitOrder != 0"
            class="item"
            effect="dark"
            content="分单"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="splitOrder(scope.row.code)">
              <i class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
          <!-- 删除 -->
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="delFunc(scope.row.code)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="business"
      title="修改核算"
      width="860"
      height="auto"
      resize
    >
      <singledetails
        ref="businessRef"
        @event2="receive2"
        @handleCancel="handleCancel"
        @openMap="positionFunc"
        @funcReject="funcReject"
      />
    </vxe-modal>
    <vxe-modal
      v-model="details"
      title="查看订单详情"
      width="1000"
      height="600"
      resize
    >
      <accounting ref="detailRef" @openMap="positionFunc" />
    </vxe-modal>
    <vxe-modal
      v-model="reject"
      title="请输入驳回理由"
      width="500"
      height="400"
      resize
    >
      <reject
        v-if="reject"
        ref="rejectRef"
        :message="parentMsg"
        @event1="receive"
      />
    </vxe-modal>
    <vxe-modal
      v-model="splitOrderFlag"
      title="子单详情"
      width="800"
      height="85%"
      resize
    >
      <splitOrder ref="splitOrderRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />

    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="88%"
      height="96%"
      resize
      remember
      @close="closePositionFunc"
    >
      <Position
        :key="timer"
        ref="positionRef"
        :order-code="code4OrderTrack"
        :positoin-info="positoinInfo"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
  </div>
</template>
<script>
import {
  orderDetailHandlePageList,
  orderHandlePC,
  isOpenMaYi
} from "@/api/transport";
import singledetails from "./components/singledetails.vue";
import accounting from "@/components/WaybillDetails";
import reject from "./components/reject.vue";
import splitOrder from "@/views/tms/order/splitOrder";
import { getLimit } from "@/utils/getLimit.js";
import Position from "../../../transportManage/waybillManage/components/components/Position.vue";
import { deleteDetail } from "@/api/transport";
export default {
  components: {
    singledetails,
    accounting,
    reject,
    splitOrder,
    Position
  },
  data() {
    return {
      vehicleNatureStatusList: [
        { value: 0, label: "待处理" },
        { value: 1, label: "无经营性质" },
        { value: 2, label: "协议未补传" },
        { value: 3, label: "平台未确认" },
        { value: 4, label: "正常" }
      ],
      freightValidList: [
        {
          value: 0,
          label: "未计算"
        },
        {
          value: 1,
          label: "不合理"
        },
        {
          value: 2,
          label: "合理"
        }
      ],
      tackList: [
        {
          value: 0,
          label: "待校验"
        },
        {
          value: 1,
          label: "无轨迹点"
        },
        {
          value: 2,
          label: "起终点无点"
        },
        {
          value: 3,
          label: "终点无点"
        },
        {
          value: 4,
          label: "起点无点"
        },
        {
          value: 5,
          label: "多次往返"
        },
        {
          value: 6,
          label: "多段缺失"
        },
        {
          value: 7,
          label: "有长距离直线"
        },
        {
          value: 8,
          label: "轨迹正常"
        }
      ],
      applyStateList: [
        {
          value: 0,
          label: "未驳回"
        },
        // {
        //   value: 1,
        //   label: "已申请"
        // },
        {
          value: 2,
          label: "已驳回"
        }
      ],
      timer: "",
      code4OrderTrack: "",
      positoinInfo: {},
      positionFlag: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportDetailHandle", //导出接口
        name: "运费核算"
      },
      message: "",
      leitype: "",
      splitOrderFlag: false,
      business: false,
      details: false,
      reject: false,
      loading: false,
      freight_search_button: false, //查询
      freight_clearAll_button: false, //清除所有行选中
      freight_batchHandle_button: false, //批量核算
      freight_detail_button: false, //详情
      freight_reject_button: false, //驳回
      freight_edit_button: false, //编辑
      freight_splitOrder_button: false, //分单
      openMaYiBlockChain: false, //是否数据上链
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: [],
        txStatusOptions: []
      },
      parentMsg: "",
      acclist: [],
      receiptOptions: [
        {
          value: "0",
          label: "未收取"
        },
        {
          value: "1",
          label: "已收取"
        },
        {
          value: "2",
          label: "已签收"
        }
      ],
      // 托运人类型
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      // 是否调单
      isTransferSearchOptions: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      options: [
        {
          value: "1",
          label: "已接单"
        },
        {
          value: "2",
          label: "已装货"
        },
        {
          value: "3",
          label: "已卸货"
        },
        {
          value: "4",
          label: "已结算"
        },
        {
          value: "5",
          label: "已打款"
        }
      ],
      partyType: this.$store.getters.party.partyType,
      listQuery: {
        deleted: 0,
        orderGmtCreatedRange: [],
        gmtCreatedRange: "",
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        gmtModifiedRange: "",
        rangeValue_start_1: "",
        rangeValue_end_1: "",
        rangeValue_start_2: "",
        rangeValue_end_2: "",
        rangeValue_start_3: "",
        rangeValue_end_3: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        lastUnloadingTimeStart: "",
        lastUnloadingTimeEnd: "",
        lastLoadingTimeStart: "",
        lastLoadingTimeEnd: "",
        gmtModifiedStart: "",
        gmtModifiedEnd: "",
        fillTimeStart: "",
        fillTimeEnd: "",
        signTimeStart: "",
        signTimeEnd: "",
        ordCreatedByName: "",
        isUnloadingConfirm: 1,
        appealStatus: 0
      },
      // Pagingconf: [],
      sumObject: {},
      isAdmin: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      // 机构列表
      branchList: this.$store.state.components.branchList,
      isShowTxStatus: ""
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.parentData.txStatusOptions = [
      { label: "未上链", value: 0 },
      { label: "货源单上链", value: 1 },
      { label: "运单创建", value: 2 },
      { label: "运单启运", value: 3 },
      { label: "已上链", value: 4 },
      { label: "运单支付单创建", value: 5 },
      { label: "运单完成", value: 6 },
      { label: "运单关闭", value: 7 }
    ];
    this.findList();
    // this.openMaYiBlockChain = dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiCredit ? dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiCredit.configValue == 1 : false;
    this.freight_search_button = getLimit("freight_search_button");
    this.freight_clearAll_button = getLimit("freight_clearAll_button");
    this.freight_batchHandle_button = getLimit("freight_batchHandle_button");
    this.freight_detail_button = getLimit("freight_detail_button");
    this.freight_reject_button = getLimit("freight_reject_button");
    this.freight_edit_button = getLimit("freight_edit_button");
    this.freight_splitOrder_button = getLimit("freight_splitOrder_button");
    this.getMaYiOpen();
  },
  methods: {
    rowClassName({ row }) {
      // console.log("行名=======", row.isFinishOrder, typeof row.isFinishOrder);
      if (row.applyStatus === 2) {
        return "row-red";
      }
    },
    formatterFreightValid(row) {
      const cellValue = row && row.freightValid;
      if (cellValue == 0) {
        return "未计算";
      } else if (cellValue == 1) {
        return "不合理";
      } else if (cellValue == 2) {
        return "合理";
      }
      return "";
    },
    formatterApplyStatus({ cellValue }) {
      if (cellValue == 0) {
        return "未驳回";
      } else if (cellValue == 2) {
        return "已驳回";
      }
    },
    formatterVehicleNatureStatus({ cellValue }) {
      const item = this.vehicleNatureStatusList.find(
        item1 => item1.value == cellValue
      );
      return item ? item.label : "待处理";
    },
    funcReject(code) {
      this.business = false;
      console.log("===========", code);
      this.rejectClick(code);
    },
    delFunc(code) {
      this.$confirm("请确认是否删除运单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          //setTimeout(() => {
          deleteDetail({ codes: code }).then(response => {
            this.$message({
              type: "success",
              message: response.msg
            });
            this.findList();
            rLoading.close();
          });
          //}, 1000000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    positionFunc(row, form) {
      const source = form || (row && typeof row === "object" ? row : {}) || {};
      this.positoinInfo = {
        vehicleLicense: source.vehicleLicense || source.licenseNumber || "",
        fillTime: source.fillTime || "",
        signTime: source.signTime || ""
      };
      this.timer = new Date().getTime();
      this.code4OrderTrack = row && typeof row === "object" ? row.code : row;
      this.positionFlag = true;
    },
    closePositionFunc() {
      this.$refs.positionRef.closeModal();
    },
    fatherSubmitFunc(modelFlag) {
      switch (modelFlag) {
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
      this.findList();
    },
    fatherCancelFunc(modelFlag) {
      switch (modelFlag) {
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
    },
    // add by JiaYK start 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    getMaYiOpen() {
      isOpenMaYi({ branchCode: this.$store.state.user.party.branchCode }).then(
        res => {
          this.isShowTxStatus = res.data;
        }
      );
    },
    // add by JiaYK end 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    receive(flag) {
      this.reject = false;
      if (flag) {
        this.findList();
      }
    },
    handleClick(c) {
      this.details = true;
      this.$refs.detailRef.Getdetails(c, true);
    },
    // 驳回
    rejectClick(c) {
      this.reject = true;
      this.parentMsg = c;
    },
    //分单
    splitOrder(row) {
      this.$refs.splitOrderRef.findList(row);
      this.splitOrderFlag = true;
    },
    businessClick(c) {
      this.business = true;
      this.$refs.businessRef.shipmentlist(c);
    },
    receive2(c) {
      this.business = false;
      this.findList();
    },
    handleCancel() {
      this.business = false;
      this.findList();
    },
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择需要结算项", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const codes = selectRecords.map(item => item.code).join(",");
        orderHandlePC({ codes }).then(response => {
          rLoading.close();
          this.$message({
            message: response.data,
            type: "success"
          });
          this.findList();
        });
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        orderDetailHandlePageList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.taxPrice = item.taxPrice + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    formatterTrackFlag(row) {
      const item = this.tackList.find(item1 => item1.value === row.trackFlag);
      return item ? item.label : "";
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    //状态翻译
    formatterReceiptStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "未收取";
        case "1":
          return "已收取";
        case "2":
          return "已签收";
        default:
          break;
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    /*
      footerCellClassName({ $rowIndex, column, columnIndex }) {
        if (columnIndex === 0) {
          if ($rowIndex === 0) {
            return 'col-blue'
          } else {
            return 'col-red'
          }
        }
      }, */
    headerCellClassName({ column, columnIndex }) {
      if (column.property === "name") {
        return "col-blue";
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (column.property === "status") {
        switch (row.status) {
          case 0:
            return "col-red";
          case 1:
            return "col-green";
          case 2:
            return "col-orange";
          case 3:
            return "col-red";
          case 4:
            return "col-green";
          case 5:
            return "col-orange";

          default:
            break;
        }
      }
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已结算";
        case 5:
          return "已打款";

        default:
          break;
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "shipmentActualFreight",
              "driverActualFreight",
              "payTaxAmount",
              "platformPrepayment",
              "shipmentActualCash",
              "driverActualCash",
              "shipmentDeliveryFeePractical",
              "platformPrepayment",
              "driverActualCash",
              "extraFee",
              "abnormalFee",
              "payOil",
              "payAmount",
              "allotOil"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "wastage") {
            return (
              this.sumObject.wastageTon +
              "吨//" +
              this.sumObject.wastageCubicMeter +
              "方//" +
              this.sumObject.wastagePieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          if (column.property === "settlementWeight") {
            return (
              this.sumObject.settlementWeightTon +
              "吨//" +
              this.sumObject.settlementWeightCubicMeter +
              "方//" +
              this.sumObject.settlementWeightPieces +
              "件"
            );
          }
          if (column.property === "extraFee") {
            return this.sumObject.extraFee;
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style>
.mytable-footer .vxe-body--row.row-red {
  background-color: rgba(255, 68, 0, 0.2);
}
.checkbox-table.vxe-table .vxe-body--row.row-checked {
  background-color: #fbf8ec;
}
.vxe-footer--row .col-blue {
  background-color: rgb(233, 20, 20);
  color: #fff;
}
.vxe-footer--row .col-red {
  background-color: rgb(32, 11, 219);
  color: #fff;
}
.mytable-footer .vxe-body--row.row-green {
  background-color: #187;
  color: #2db7f5;
}
.mytable-footer .vxe-header--column.col-blue {
  background-color: #2db7f5;
  color: #fff;
}
.mytable-footer .vxe-body--column.col-red {
  color: #f00;
}
.mytable-footer .vxe-body--column.col-orange {
  color: #f60;
}
.mytable-footer .vxe-body--column.col-green {
  color: rgb(29, 47, 202);
}
</style>
